
document.addEventListener('DOMContentLoaded', function() {

  // --- Load Fuse.js dynamically if needed ---
  function loadFuse(callback) {
    if (window.Fuse) return callback();
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/fuse.js@6.6.2/dist/fuse.min.js';
    s.async = true;
    s.onload = callback;
    document.head.appendChild(s);
  }

  loadFuse(() => {
    // Wait for FAQ sections to actually be in the DOM
    const init = () => {
      const faqDetails = document.querySelectorAll('.yy-faq-section details');
      if (!faqDetails.length) {
        // retry if content not yet loaded
        return setTimeout(init, 100);
      }

      const yyFaqAll = Array.from(faqDetails).map(d => ({
        element: d,
        question: d.querySelector('summary')?.textContent || '',
        answer: d.querySelector('p')?.textContent || '',
        category: d.closest('.yy-faq-section')?.dataset.category || ''
      }));

      const yyFaqFuse = new Fuse(yyFaqAll, {
        keys: ['question', 'answer', 'category'],
        threshold: 0.3
      });

      const yyFaqSearchInput = document.getElementById('yy-faq-search-input');
      const yyFaqSections = document.querySelectorAll('.yy-faq-section');
      const yyFaqLinks = document.querySelectorAll('#yy-faq-sidebar-links a');
      let yyFaqCategory = 'all';

      yyFaqLinks.forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault();
          yyFaqLinks.forEach(l => l.classList.remove('yy-faq-active'));
          link.classList.add('yy-faq-active');
          yyFaqCategory = link.dataset.category;
          filterFaq();
          

                  });
      });

      yyFaqSearchInput.addEventListener('input', () => filterFaq());

      function filterFaq() {
        const query = yyFaqSearchInput.value.trim().toLowerCase();

        // Always start by showing all
        yyFaqSections.forEach(sec => sec.style.display = 'block');
        if (!query && yyFaqCategory === 'all') return;

        // Search results via Fuse
        const results = query
          ? yyFaqFuse.search(query).map(r => r.item.element)
          : yyFaqAll.map(f => f.element);

        // Hide everything first
        yyFaqSections.forEach(sec => sec.style.display = 'none');

        // Filter by category if needed
        const matched = results.filter(el =>
          yyFaqCategory === 'all' || el.closest('.yy-faq-section').dataset.category === yyFaqCategory
        );

        // Show only matching sections
        matched.forEach(el => {
          const section = el.closest('.yy-faq-section');
          if (section) section.style.display = 'block';
        });
      }
    };

    init();
  });
});

